export enum UserStatus {
    INVITED = "invited",
    ACTIVE = "active",
    INACTIVE = "inactive",
}
